export const capitalizeFirstLetter = (string: string) => string.charAt(0).toUpperCase() + string.slice(1);

export const capitalizeLetters = (string: string) => string.split(" ").map(capitalizeFirstLetter).join(" ");

export const lowerFirstLetter = (string: string) => string.charAt(0).toLowerCase() + string.slice(1);

export const findFirstBracket = (string: string) => string.split("(")[0];
